import { Switch, styled } from '@mui/material';

export const ToggleSwitchStyled = styled(Switch)(({ theme }) => ({
  width: '5.6rem',
  height: '3.6rem',
  padding: theme.spacing(1),
  '& .MuiSwitch-thumb': {
    width: '2.2rem',
    height: '2.2rem',
  },
  '& .MuiSwitch-track': {
    borderRadius: '3.5rem',
    backgroundColor: theme.palette.grey[300],
    opacity: 1,
  },
  '& .MuiSwitch-switchBase': {
    margin: '0.2rem',
    padding: '0.5rem',
    transitionDuration: '300ms',
    '&:active': {
      transform: `scale(1.1)`,
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: theme.palette.common.white,
    transform: 'scale(1) translateX(1.9rem)',
    '&:active': {
      transform: `scale(1.1) translateX(1.8rem)`,
    },
    '.MuiTouchRipple-child': {
      backgroundColor: theme.palette.primaryMedium.main,
    },
    '&.Mui-focusVisible': {
      backgroundColor: theme.palette.primaryMedium.main,
      opacity: 1,
    },
    '& + .MuiSwitch-track': {
      backgroundColor: theme.palette.primary.main,
      opacity: 1,
    },
  },
}));
